import { connect } from "react-redux";
import { getValue } from "store/languages";
import { sendMessageToAi, loadAiUserSession, loadAiSessions, generateSessionTitle, setSession } from "store/assistent";
import SessionsHistoryController from "./sessions-history-controller";
import { setShowLeftMenu } from 'store/side-bar';

let mapStateToProps = (state) => {
    return {
        sessions: state.aiAssistant.sessions,
        accountId: state.Account.id,
        companyId: state.Account.companyId,
        session: state.aiAssistant.session,
        showLeftMenu: state.SideBarMenu.showLeftMenu,
        deviceType: state.header.deviceType,
        selectedLanguage: state.languages.selectedLanguage,
        isLoading: state.aiAssistant.isLoading,
        titleLoadingId: state.aiAssistant.titleLoadingId,
        titleLoadingError: state.aiAssistant.titleLoadingError
    }
}

const SessionsHistoryContainer = connect(mapStateToProps, {     
                                                        getValue,
                                                        setSession,
                                                        loadAiUserSession,
                                                        setShowLeftMenu,
                                                        generateSessionTitle
                                    })(SessionsHistoryController)

export default SessionsHistoryContainer